import React from "react";
import { useNavigate } from "react-router-dom";
import { css, useTheme } from "@emotion/react";

import BurgerNavSmallSubMenuTitle from "core/Components/HamburgerNavigations/small/BurgerNavSmallSubMenuTitle";

type Props = {
    isHeaderMenu?: boolean,
    subMenu: StandardPage,
    currentURLSegment?: string,
    selectedSegments?: string[],
    closeMenuHandler: Function,
};

const BurgerNavSmallSubMenuBox: React.FC<Props> = ({
    isHeaderMenu = false,
    subMenu,
    currentURLSegment = "",
    selectedSegments = undefined,
    closeMenuHandler,
}) => {
    const theme = useTheme();
    const navigate = useNavigate();

    const onClickMenuHandler = () => {
        if (subMenu.isClickable) {
            if (currentURLSegment !== subMenu.uRLSegment) {
                navigate(subMenu.linkUrl);
            }
            closeMenuHandler();
        }
    };

    const style = css`
        display: flex;
        align-items: center;
        padding: 0 65px;
        cursor: pointer;
        background-color: ${theme.colours.white};
        
        ${(currentURLSegment && currentURLSegment === subMenu.uRLSegment) && css`
            background-color: ${theme.colours.gallery2};
        `}
        
        &:not(:last-of-type) {
            border-bottom: 2px solid ${theme.colours.cornflower};
        }
        
        ${theme.breakpoints.only("md")} {
            height: 72px;
        }

        ${theme.breakpoints.only("sm")} {
            height: 75px;
        }

        ${theme.breakpoints.down("xs")} {
            height: 70px;
        }
    `;

    return (
        (!isHeaderMenu || (isHeaderMenu && subMenu.isClickable)) ? (
            <div css={style} onClick={onClickMenuHandler}>
                <BurgerNavSmallSubMenuTitle
                    isHeaderMenu={isHeaderMenu}
                    subMenu={subMenu}
                    selectedSegments={selectedSegments}
                >
                    {subMenu.title}
                </BurgerNavSmallSubMenuTitle>
            </div>
        ) : null
    );
};

export default BurgerNavSmallSubMenuBox;
